export default function CountryList({ continents, onEdit }) {
  const total = continents.reduce(
    (sum, c) => sum + c.countries.length, 0
  );

  return (
    <div style={{ marginTop: 24 }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', marginBottom: 16
      }}>
        <span style={{
          fontSize: 10, color: '#454860',
          letterSpacing: '0.1em', textTransform: 'uppercase',
          fontFamily: 'monospace'
        }}>
          {total} countries · 5 continents
        </span>
        {onEdit && (
          <button
            onClick={onEdit}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#10B981', padding: 4, lineHeight: 1,
              fontSize: 10, fontFamily: 'monospace',
              letterSpacing: '0.1em', textTransform: 'uppercase',
            }}
            title="Add countries or record more visits"
          >
            Edit
          </button>
        )}
      </div>

      {continents.map(continent => (
        <div key={continent.name} style={{ marginBottom: 20 }}>
          <div style={{
            fontSize: 9, color: '#454860',
            letterSpacing: '0.12em', textTransform: 'uppercase',
            fontFamily: 'monospace', marginBottom: 8,
            paddingBottom: 6, borderBottom: '0.5px solid rgba(255,255,255,0.06)'
          }}>
            {continent.name} · {continent.countries.length}
          </div>
          <div style={{
            display: 'flex', flexWrap: 'wrap', gap: 6
          }}>
            {continent.countries.map(country => (
              <div
                key={country.code}
                style={{
                  padding: '4px 10px',
                  borderRadius: 20,
                  background: 'rgba(255,255,255,0.03)',
                  border: '0.5px solid rgba(255,255,255,0.06)',
                  fontSize: 11,
                  color: country.visits > 1 ? '#10B981' : '#b0b4c0',
                  fontFamily: 'system-ui',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5
                }}
              >
                {country.name}
                {country.visits > 1 && (
                  <span style={{
                    fontSize: 9, color: '#10B981',
                    fontFamily: 'monospace', opacity: 0.7
                  }}>
                    ×{country.visits}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
